
  <template>
  <v-form v-model='valid' ref='formDatos' lazy-validation>
    <v-container>
      <v-layout align-center justify-end v-if='!modificar'>
        <v-btn fab color="primary" class="botonEdit"
          @click='modificarDatos()'          
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-layout>
      <v-layout wrap v-if='codError !== null'>
        <v-flex xs12 md12>
          <v-alert :value='true' :type='status_error'>{{this.msgError}}</v-alert>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm4 md4>
          <v-select
            :no-data-text="$t('comun.sin_datos')"
            v-model='documentoIdentificacion'
            :items='itemsDocId'
            item-text='tipdoc_descripcion'
            item-value='tipdoc_codigo'
            label='Documento de Identificación*'
            @change='tipoDocumento()'
            :rules='dRules'
            required
            :disabled='!modificar'
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4 md4 v-if='this.documentoIdentificacion===1'>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
              <v-text-field
                v-on='on'
                v-model='nroDocumento'
                label='Número de Documento*'
                :disabled='!modificar'
                maxlength='10'
                :rules='ciRules'
              ></v-text-field>
            </template>
            <span>Digite el número del documento de identificación (SIN ESPACIOS VACIOS)</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 sm4 md4 v-if='this.documentoIdentificacion===3'>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
              <v-text-field
                v-on='on'
                v-model='nroPasaporte'
                label='Número de Pasaporte'
                :disabled='!modificar'
                maxlength='25'
                :rules='pasaporteRules'
              ></v-text-field>
            </template>
            <span>Digite el número del pasaporte (SIN ESPACIOS VACIOS) por Ejemplo A-12345</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 sm2 md2 v-if='this.documentoIdentificacion===1'>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
              <v-text-field
                v-on='on'
                v-model='complemento'
                :rules='complementoRules'
                label='Complemento SEGIP'
                :disabled='!modificar'
                maxlength='2'
                class="text-normal"
              ></v-text-field>
            </template>
            <span>Complemento alfanumérico otorgado por el SEGIP, por ejemplo "1K", no corresponde a la extensión.</span>
          </v-tooltip>
        </v-flex>
        <!-- <v-flex xs12 sm2 md2>
          <v-select
          :no-data-text="$t('comun.sin_datos')"
            v-model='lugarExpedicion'
            :items='itemsLugarExpedicion'
            label='Lugar de expedición'
            item-text='dep_descripcion'
            item-value='dep_codigo'
            :disabled='!modificar'
            v-show='false'
          ></v-select>
        </v-flex> -->
        <v-flex xs4 sm4 md12></v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model='apellidoPaterno'
            label='Apellido Paterno'
            :disabled='!modificar'
            maxlength='60'
			      :rules="$validate(['text_area'])"
            @keyup="apellidoPaterno = apellidoPaterno ? apellidoPaterno.replace(/[%#{}*]/g, '') : ''" 
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field
            v-model='apellidoMaterno'
            label='Apellido Materno'
            :disabled='!modificar'
            maxlength='60'
			      :rules="$validate(['text_area'])"
            @keyup="apellidoMaterno = apellidoMaterno ? apellidoMaterno.replace(/[%#{}*]/g, '') : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
              <v-text-field
                v-on='on'
                v-model='nombres'
                label='Nombres*'
                :rules='generalRules'
                required
                :disabled='!modificar'
                maxlength='100'
                @keyup="nombres = nombres ? nombres.replace(/[%#{}*]/g, '') : ''"
              ></v-text-field>
            </template>
            <span>Revise que los apellidos y nombres estén transcritos correctamente.</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex sm12 md12>
          <div
            class='v-label theme--light error--text'
            v-show='codErrorApellido !== null'
          >{{this.msgApellido}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
           <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
          <v-textarea
            @change="observaciones = $util.sanitiza(observaciones)"
            v-model='observaciones'
            label='Observaciones'
            :disabled='!modificar'
            maxlength='250'
            v-on='on'
            :counter='250'
            hint='Máximo 250 caracteres.'
            persistent-hint
            :rules="$validate(['text_area'])"
            rows="1"
            auto-grow
          ></v-textarea>
                    </template>
            <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos del cónyuge. 
</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <br />
      <v-layout wrap>
        <v-flex sm12 md12>
          <v-subheader>
            <p class='plomo--text'>Por favor llene los campos requeridos*</p>
          </v-subheader>
        </v-flex>
      </v-layout>
      <v-layout v-if='this.documentoIdentificacion !== 3' wrap>
        <v-flex v-if="modificar" sm12 md12>
          <v-subheader>
            <strong><p class='light-green--text'>El proceso de validación con el Segip es opcional, siendo útil para confirmar la escritura de los nombres según el documento de identidad.</p></strong>
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-dialog v-model='dialogHabilitar' scrollable persistent max-width='700px'>
          <v-card>
            <v-card-title><h4><v-icon color="yellow">warning</v-icon>Advertencia</h4></v-card-title>
            <v-card-text wrap>
              <v-flex sm12 md12>
                <strong><p class='light-green--text'>El llenado de los campos Nacionalidad y Fecha de Nacimiento, son para la validación con el SEGIP, los campos mencionados no son registrados</p></strong>
              </v-flex>
              <v-layout wrap>
                <v-flex sm6 md6>
                  <v-select
                  :no-data-text="$t('comun.sin_datos')"
                    v-model='tipoNacionalidad'
                    :items='itemTipoNacionalidad'
                    item-text='tipoNacionalidad_descripcion'
                    item-value='tipoNacionalidad_codigo'
                    label='Nacionalidad'
                    :disabled='!modificar'
                    color='light-green'
                    hint='Dato opcional para validar'
                    persistent-hint
                    teal
                  ></v-select>
                </v-flex>
                <v-flex sm6 md6>
                  <global-date-input-picker
                    v-model="date" :hint="'Formato : DD/MM/AAAA (Dato opcional para validar)'" label="Fecha de Nacimiento*">
                  </global-date-input-picker>  
                </v-flex>
              </v-layout>
              <p>Digite la letras y/o números que aparecen en la imagen </p>
              <v-layout row wrap>
                <v-flex md3 offset-md1>
                  <img
                    :src="imgb64"
                    alt="Bolivia">
                </v-flex>
                <v-flex md3 offset-md1>
                  <v-text-field
                    v-model="captcha"
                    label='Respuesta'
                    :required="this.useCaptcha"
                    :maxlength="this.lengthCaptcha"
                    @keydown.enter="login()"
                  ></v-text-field>
                </v-flex>
                <v-flex md1>
                  <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading='loadingButtonValida' color='primary' @click='validar()'>
                <v-icon>check</v-icon>&nbsp;Continuar
              </v-btn>
              <v-btn color='error' @click='dialogHabilitar=false'>
                <v-icon>cancel</v-icon>&nbsp;Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-btn color='primary' @click='modificarDatos()' v-show='!modificar'>
        <v-icon>create</v-icon>&nbsp;Modificar
      </v-btn>
      <v-btn :loading='loadingButton' color='primary' @click='guardaConyuge' v-show='modificar'>
        <v-icon>save</v-icon>&nbsp;Guardar
      </v-btn>
      <v-btn v-if='this.documentoIdentificacion !== 3' color='validate' class="v-btn__content_validar" @click='verificaHabilitacion()' v-show='modificar'>
        <v-icon>beenhere</v-icon>&nbsp;Validar
      </v-btn>
      <v-btn color='warning' v-show='modificar' @click='eliminaConyuge'>
        <v-icon>delete</v-icon>&nbsp;Eliminar
      </v-btn>
      <v-btn color='error' v-show='modificar' @click='cancelarAction'>
        <v-icon>cancel</v-icon>&nbsp;Cancelar
      </v-btn>
    </v-container>
    <v-spacer></v-spacer>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Captcha from '../portal/mixins/captcha.js';
export default {
  mixins: [ Captcha, validate ],
  mounted () {
    this.$root.$on('clickedGuardarConyugue', () => {
      this.guardaConyuge();
    });
  },
  created () {
    this.obtieneConyuge();
    this.obtieneTipoDocumento();
    // Formateo de fecha actual
    const [year, month, day] = this.fechaActual.split('-');
    this.fechaActual = `${day}/${month}/${year}`;
  },
  data: () => ({
    loadingButton: false,
    loadingButtonValida: false,
    tipParCodigo: 9, // TipoParentesco  9: ESPOSO(A)
    apellidoPaterno: '',
    apellidoMaterno: '',
    nombres: '',
    documentoIdentificacion: '',
    nroDocumento: '',
    nroPasaporte: '',
    nroCiPasaporte: '',
    complemento: '',
    tipoNacionalidad: 0,
    itemTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'NACIONAL',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'EXTRANJERO',
        tipoNacionalidad_codigo: '2'
      }
    ],
    fechaNacimiento: '',
    lugarExpedicion: 0,
    itemsLugarExpedicion: null,
    observaciones: '',
    itemsDocId: null,
    modificar: false,
    maskFecha: '##/##/####',
    fechaActual: new Date().toISOString().substr(0, 10),
    fechaNacimientoCom: new Date().toISOString().substr(0, 10),
    codParentesco: null,
    codError: null,
    msgError: null,
    msgApellido: null,
    codErrorApellido: null,
    codRptaSegip: null,
    msgErrorSegip: null,
    status_error: null,
    valid: true,
    reglaVariable: null,
    dialogHabilitar: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    generalRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*(),.;:=#°ñÑÁáÉéÍíóÓúÚüÜ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    pasaporteRules: [
      v => !!v || 'Este campo es requerido pasaporte',
      v =>
        /^[A-Za-z0-9]{1,4}-[0-9]{1,10}$/.test(v) ||
        'El número de pasaporte no es válido'
    ],
    ciRules: [
      v => !!v || 'Este campo es requerido ci',
      v => /^[0-9]*$/.test(v) || 'El número de ci no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    menu: false,
    date: '',
    imgb64: '',
    captcha: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA
  }),
  methods: {
    async crearImagenCaptcha () {
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    guardaConyuge () {
      if (this.complemento === 'lp' || this.complemento === 'cb' || this.complemento === 'sc' ||
          this.complemento === 'pt' || this.complemento === 'or' || this.complemento === 'ch' ||
          this.complemento === 'tj' || this.complemento === 'bn' || this.complemento === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.complemento = '';
      }
      if (this.$refs.formDatos.validate()) {
        this.loadingButton = true;
        if (this.documentoIdentificacion === 1) {
          if (this.complemento !== '' && this.nroDocumento !== '') {
            this.nroCiPasaporte = this.nroDocumento + '-' + this.complemento;
          } else {
            this.nroCiPasaporte = this.nroDocumento;
          }
        } else {
          this.nroCiPasaporte = this.nroPasaporte;
        }
        let params = {
          cod_parentesco: this.codParentesco,
          tipo_documento: this.documentoIdentificacion,
          nro_documento: this.nroCiPasaporte,
          cod_lugar_exp: this.lugarExpedicion,
          apellido_paterno: this.apellidoPaterno,
          apellido_materno: this.apellidoMaterno,
          nombres: this.nombres,
          observaciones: this.observaciones,
          tipo_parentesco: this.tipParCodigo
        };
        if (
          (this.apellidoPaterno !== '' && this.apellidoMaterno === '') ||
          (this.apellidoPaterno === '' && this.apellidoMaterno !== '') ||
          (this.apellidoPaterno !== '' && this.apellidoMaterno !== '')
        ) {
          this.$service
            .post('djbr_registro/conyuges', params)
            .then(response => {
              if (response) {
                if (response.err_codigo === 0) {
                  this.loadingButton = false;
                  this.reinicializa();
                  // this.obtieneConyuge();
                  this.editMode = false;
                  this.dialog = false;
                  this.$message['success'](response.err_mensaje);
                  let ctrl = this.$storage.get('ctrl');
                  ctrl.datos_generales.conyuge = false;
                  this.$storage.set('ctrl', ctrl);
                } else {
                  this.$message['warning'](response.err_mensaje);
                  this.loadingButton = false;
                }
              } else {
                this.loadingButton = false;
              }
            })
            .catch(e => {
              console.log(e);
              this.loadingButton = false;
            });
        } else {
          this.codErrorApellido = 0;
          this.msgApellido = 'Debe ingresar un Apellido';
          this.$message['warning']('DEBE INGRESAR AL MENOS UN APELLIDO');
          this.loadingButton = false;
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    showMessage (type, men) {
      this.$message[type](`${men}`);
    },
    eliminaConyuge () {
      if (this.codParentesco != null) {
        this.$service
          .delete(`djbr_registro/parentesco/${this.codParentesco}`)
          .then(response => {
            if (response) {
              if (response.err_codigo === 0) {
                this.reinicializa();
                this.modificar = true;
                this.dialog = false;
                this.$message['success'](response.err_mensaje);
              } else {
                this.$message['warning'](response.err_mensaje);
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        this.showMessage(
          'warning',
          'NO TIENE REGISTRADO CONYUGE O CONVIVIENTE PARA REALIZAR LA ELIMINACIÓN'
        );
      }
    },
    cancelarAction () {
      this.codError = null;
      this.modificar = !this.modificar;
      this.reinicializa();
      this.obtieneConyuge();
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.conyuge = false;
      this.$storage.set('ctrl', ctrl);
    },
    obtieneTipoDocumento () {
      this.$service.get('tipos_documentos', {}).then(res => {
        if (res) {
          this.itemsDocId = res;
        }
      });
    },
    obtieneConyuge () {
      this.$service.get('djbr_registro/parentesco/1', {}).then(response => {
        // 1 Esposo(a)
        if (response) {
          // this.$service.get('departamentos', {}).then(res => {
          //   if (res) {
          //     this.itemsLugarExpedicion = res;
          //   }
          // });

          if (response.par_codigo === -1) {
            this.modificar = true;
            // let ctrl = this.$storage.get('ctrl');
            // ctrl.datos_generales.conyuge = true;
            // this.$storage.set('ctrl', ctrl);
          } else {
            this.apellidoPaterno = response.par_paterno;
            this.apellidoMaterno = response.par_materno;
            this.nombres = response.par_nombres;
            this.documentoIdentificacion = response.tipdoc_codigo;
            if (this.documentoIdentificacion === 1) {
              // Seteo de datos de complemento
              if (
                response.par_docidentidad.substring(response.par_docidentidad.length - 3, response.par_docidentidad.length - 2) === '-') {
                this.nroDocumento = response.par_docidentidad.substring(0, response.par_docidentidad.length - 3);
                this.complemento = response.par_docidentidad.substring(response.par_docidentidad.length - 2, response.par_docidentidad.length);
              } else {
                this.nroDocumento = response.par_docidentidad;
                this.complemento = '';
              }
            } else {
              this.nroPasaporte = response.par_docidentidad;
            }

            this.tipoNacionalidad = 0; // Valor por defecto
            this.lugarExpedicion = response.dep_codigo;
            this.observaciones = response.par_observacion;
            this.codParentesco = response.par_codigo;
            this.modificar = false;
          }
        }
      });
    },
    validar () {
      if (this.captcha !== '') {
        this.loadingButtonValida = true;
        this.fechaNacimiento = this.date;
        if (this.documentoIdentificacion === 1) {
          this.nroDocumento = this.nroDocumento;
        } else {
          this.nroDocumento = this.nroPasaporte;
        }
        if (
          this.nroDocumento === '' ||
          this.tipoNacionalidad === 0 ||
          this.fechaNacimiento === '' ||
          this.fechaNacimiento === null ||
          (this.apellidoPaterno === '' && this.apellidoMaterno === '') ||
          this.nombres === ''
        ) {
          this.showMessage(
            'warning',
            '<b>Para realizar la validación</b><br>Debe ingresar el tipo de Nacionalidad, el Número de Documento, Nombres y Apellido(s)'
          );
          this.loadingButtonValida = false;
        } else {
          // Validacion de fechas Desde y Hasta
          this.fechaNacimientoCom = `${this.fechaNacimiento.substring(0, 2)}/${this.fechaNacimiento.substring(2, 4)}/${this.fechaNacimiento.substring(4, 8)}`;
          if (
            parseInt(Date.parse(this.fechaNacimientoCom)) >=
            parseInt(Date.parse(this.fechaActual))
          ) {
            this.$message['warning'](
              'La fecha  de nacimiento no debe ser mayor o igual a la fecha actual..'
            );
            this.loadingButtonValida = false;
          } else {
            if (this.documentoIdentificacion === 1) {
              if (this.complemento !== '' && this.nroDocumento !== '') {
                this.nroCiPasaporte = this.nroDocumento + '-' + this.complemento;
              } else {
                this.nroCiPasaporte = this.nroDocumento;
              }
            } else {
              this.nroCiPasaporte = this.nroPasaporte;
            }
            let params = {
              tipo_persona: this.tipoNacionalidad,
              NumeroDocumento: this.nroCiPasaporte,
              FechaNacimiento: this.fechaNacimiento,
              PrimerApellido: this.apellidoPaterno,
              SegundoApellido: this.apellidoMaterno,
              nombres: this.nombres,
              token: this.tokenCaptcha,
              captcha: this.captcha
            };
            this.$service
            .post(`djbr_registro/contrastacion_segip`, params)
            .then(responseSegip => {
              if (responseSegip) {
                if (responseSegip.err_existente === 0) {
                  this.$message['success'](responseSegip.err_mensaje);
                  responseSegip.finalizado = true;
                  this.dialogHabilitar = false;
                  this.loadingButtonValida = false;
                }
                if (responseSegip.err_existente === 1) {
                  this.$message['info'](responseSegip.err_mensaje);
                  this.crearImagenCaptcha();
                  this.loadingButtonValida = false;
                  responseSegip.finalizado = false;
                }
                if (responseSegip.error_codigo === 503) {
                  this.$message['info']('El servicio de contrastación no está disponible, se continuará sin esta verificación.', 'SEGIP', {timeout: 15000});
                  responseSegip.finalizado = true;
                  this.crearImagenCaptcha();
                  this.loadingButtonValida = false;
                  this.dialogHabilitar = false;
                }
              } else {
                this.crearImagenCaptcha();
                this.loadingButtonValida = false;
              }
            }).catch(e => {
              this.crearImagenCaptcha();
              console.log(e);
              this.loadingButtonValida = false;
            });
          }
        }
      } else {
        this.$message['warning']('EL CAPTCHA ES REQUERIDO');
      }
    },
    verificaHabilitacion () {
      if (
        this.nroDocumento === '' ||
        (this.apellidoPaterno === '' && this.apellidoMaterno === '') ||
        this.nombres === ''
      ) {
        this.showMessage(
          'warning',
          '<b>Para realizar la validación</b><br>Debe ingresar los valores del Número Documento, Nacionalidad, Fecha de Nacimiento, Apellido paterno y/o Apelllido materno  y Nombres del formulario'
        );
      } else {
        this.crearImagenCaptcha();
        this.dialogHabilitar = true;
      }
    },
    tipoDocumento () {
      if (this.documentoIdentificacion === 1) {
        this.nroDocumento = this.nroPasaporte;
        this.nroPasaporte = '';
      } else {
        this.nroPasaporte = this.nroDocumento;
        this.nroDocumento = '';
      }
    },
    reinicializa () {
      this.documentoIdentificacion = '';
      this.lugarExpedicion = 0;
      this.nroDocumento = '';
      this.nroPasaporte = '';
      this.nroCiPasaporte = '';
      this.complemento = '';
      this.fechaNacimiento = '';
      this.tipoNacionalidad = 0;
      this.apellidoPaterno = '';
      this.apellidoMaterno = '';
      this.nombres = '';
      this.observaciones = '';
      this.codErrorApellido = null;
      this.msgApellido = null;
      this.$refs.formDatos.resetValidation();
    },
    modificarDatos () {
      this.modificar = !this.modificar;
      let ctrl = this.$storage.get('ctrl');
      ctrl.datos_generales.conyuge = true;
      this.$storage.set('ctrl', ctrl);
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
};
</script>
<style>
  .v-btn__content_validar {
      color: #fff !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/datosGenerales/conyuge.vue